module.exports = __webpack_public_path__ + "static/img/047 2.22b46db7.jpg";